import React from "react";

function InfoIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            width="15px"
            height="15px"
            className="cursor-pointer"
        >
            <path d="M50 0C22.39 0 0 22.39 0 50s22.39 50 50 50 50-22.39 50-50S77.61 0 50 0zm.62 75.53c.44.23.96.23 1.4 0 .86-.63 1.65-1.36 2.34-2.17 1-1.19 1.88-2.48 2.87-3.82l1.39.84c-2 3.34-4.06 6.44-7.12 8.76a11.041 11.041 0 01-5.58 2.33c-4.77.54-7.82-2.71-6.68-7.39 1-4.11 2.27-8.16 3.43-12.24s2.33-8.32 3.51-12.46c.1-.41.17-.82.21-1.24.34-1.31-.45-2.65-1.76-2.99-.15-.04-.3-.06-.45-.07-.72-.06-1.45-.09-2.18-.08.01-.24.05-.48.11-.71l.14-1 17.24-2.76-1.2 4.18-.27 1c-2.5 8.73-5.01 17.5-7.53 26.29-.26.69-.42 1.41-.49 2.14 0 .53.22 1.04.62 1.39zM54.76 31a6.214 6.214 0 01-6.18-6.26v-.02a6.21 6.21 0 1112.42 0c0 3.45-2.79 6.25-6.24 6.28z"></path>
        </svg>
    );
}

export default InfoIcon;
